import { User } from "../types";

export function processVisibilityForUserWithAuthRules(user: User, auth_rules: any): boolean {
  let isVisibleForAuthRules = false;

  if (!auth_rules) {
    isVisibleForAuthRules = false;
  } else {
    if (
      !isVisibleForAuthRules &&
      auth_rules.type_external &&
      user.type_external
    ) {
      isVisibleForAuthRules = auth_rules.type_external?.includes(user.type_external);
    }

    if (
      !isVisibleForAuthRules &&
      auth_rules.id_external
    ) {
      isVisibleForAuthRules = auth_rules.id_external?.includes(String(user.id));
    }

    if (
      !isVisibleForAuthRules &&
      auth_rules.user_email &&
      user.email
    ) {
      auth_rules.user_email.map((email: string) => {
        const emailParts = email.split("@");
        if (
          (emailParts[0] === "*" && !emailParts[1]) ||
          (emailParts[0] === "*" && emailParts[1] === user.email?.split("@")[1])
        ) {
          isVisibleForAuthRules = true;
        } else {
          if (email === user.email) {
            isVisibleForAuthRules = true;
          }
        }
      });
    }

    if (
      !isVisibleForAuthRules &&
      auth_rules.user_id &&
      user.id
    ) {
      isVisibleForAuthRules = auth_rules.user_id?.includes(String(user.id));
    }

    if (
      !isVisibleForAuthRules &&
      auth_rules.allowed_users &&
      user.email
    ) {
      isVisibleForAuthRules = auth_rules.allowed_users.includes(user.email) ||
                              auth_rules.allowed_users.includes('*');
    }
  }

  // Check same visibility (reverse) for excluded field
  if (auth_rules) {
    if (auth_rules?.excluded) {
      if (
        isVisibleForAuthRules &&
        auth_rules.excluded?.type_external &&
        user.type_external
      ) {
        isVisibleForAuthRules = !auth_rules.excluded?.type_external?.includes(user.type_external);
      }

      if (
        isVisibleForAuthRules &&
        auth_rules.excluded?.id_external
      ) {
        isVisibleForAuthRules = !auth_rules.excluded?.id_external?.includes(String(user.id));
      }

      if (
        isVisibleForAuthRules &&
        auth_rules.excluded?.user_email &&
        user.email
      ) {
        auth_rules.excluded?.user_email.map((email: string) => {
          const emailParts = email.split("@");
          if (
            (emailParts[0] === "*" && !emailParts[1]) ||
            (emailParts[0] === "*" &&
              emailParts[1] === user.email?.split("@")[1])
          ) {
            isVisibleForAuthRules = false;
          } else {
            if (email === user.email) {
              isVisibleForAuthRules = false;
            }
          }
        });
      }

      if (
        isVisibleForAuthRules &&
        auth_rules.excluded?.user_id &&
        user.id
      ) {
        isVisibleForAuthRules = !auth_rules.excluded?.user_id?.includes(String(user.id));
      }
    }
  }

  return isVisibleForAuthRules;
};